import { ChatMessageItem } from "../models/ChatStores";

export const getLastMessage = (chatMessages?: Array<ChatMessageItem>): ChatMessageItem | undefined => {
  if (!chatMessages || !chatMessages?.length) {
    return;
  }

  return chatMessages[chatMessages.length - 1];
}